import menu from './menu.svg'
import close from './close.svg'

const images = [
  {
    src: '/games/adastra.avif',
    alt: 'Image 1',
    title: 'Ad Astra Imperium',
    description: 'Ad Astra Imperium is a space exploration game where you take on the role of a space captain. Explore the galaxy, trade goods, and battle other ships; but most importantly colonize new worlds. As you expand your empire, you will encounter other factions and must decide whether to befriend them or go to war. The fate of the galaxy is in your hands!'
  },
  {
    src: '/games/game_2.avif',
    alt: 'Image 2',
    title: 'Kingdoms in Pawril',
    description: 'Kingdoms is Peril is an adventure game where personified animals have achieved the technological advances that come with being in the medeival age. Dive into a world where Carnivores and Herbivores battle it out in an all out faction war!'
  },
  {
    src: '/games/game_3.avif',
    alt: 'Image 3',
    title: 'Synesthesia',
    description: 'TBD'
  },
  {
    src: '/games/game_1.avif',
    alt: 'Image 1',
    title: 'Perilous Pearls',
    description: 'Perilous Perals is a mobile ...'
  }
  /*
  {
    src: '/games/game_2.avif',
    alt: 'Image 2',
    title: 'Game 2',
    description: 'Game 2 is a ...'
  },
  {
    src: '/games/game_3.avif',
    alt: 'Image 3',
    title: 'Game 3',
    description: 'Game 3 is a ...'
  } */
]

export {
  menu,
  close,
  images
}
